import React from 'react'
import { useUser } from '../context/userContext';

const YourRewards = () => {

    const {premiumReward, taskPoints, checkinRewards, premium, miningTotal} = useUser();

    const formatNumber = (number) => {
        if (number === undefined || number === null || isNaN(number)) {
          return '';
        }
    
        if (number >= 1000000) {
          return (number / 1000000).toFixed() + 'M';
        } else if (number >= 100000) {
          return (number / 1000).toFixed(0) + 'K';
        } else {
          return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
        }
      };

  return (
    <div className='w-full flex flex-col space-y-3'>
      <h3 className='font-medium text-[18px] pb-2'>
        Your rewards
      </h3>

      {/* Checkin Rewards Card */}
      <div className="w-full rounded-[16px] p-4 bg-gradient-to-br from-[#1f2023] to-[#252629] 
      border border-[#2c2d30] shadow-lg hover:shadow-xl transition-all duration-200">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-4">
            <div className='flex items-center justify-center bg-gradient-to-br from-[#2a2b2e] to-[#323438] 
            h-[45px] w-[45px] rounded-full border border-[#3d3e42] shadow-inner'>
              <img alt="reward" src='/checkin.svg' className='w-[20px]' />
            </div>
            
            <div>
              <h3 className="text-[15px] font-medium text-white">
                Checkin Rewards
              </h3>
            </div>
          </div>

          <span className='text-[15px] font-semibold text-primary bg-primary/10 
          px-3 py-1 rounded-full border border-primary/20'>
            +{formatNumber(checkinRewards)} $TFlash
          </span>
        </div>
      </div>

      {/* Tasks Rewards Card */}
      <div className="w-full rounded-[16px] p-4 bg-gradient-to-br from-[#1f2023] to-[#252629] 
      border border-[#2c2d30] shadow-lg hover:shadow-xl transition-all duration-200">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-4">
            <div className='flex items-center justify-center bg-gradient-to-br from-[#2a2b2e] to-[#323438] 
            h-[45px] w-[45px] rounded-full border border-[#3d3e42] shadow-inner'>
              <img alt="reward" src='/gold.svg' className='w-[20px]' />
            </div>
            
            <div>
              <h3 className="text-[15px] font-medium text-white">
                Tasks Rewards
              </h3>
            </div>
          </div>

          <span className='text-[15px] font-semibold text-primary bg-primary/10 
          px-3 py-1 rounded-full border border-primary/20'>
            +{formatNumber(taskPoints)} $TFlash
          </span>
        </div>
      </div>

      {/* Mining Rewards Card */}
      <div className="w-full rounded-[16px] p-4 bg-gradient-to-br from-[#1f2023] to-[#252629] 
      border border-[#2c2d30] shadow-lg hover:shadow-xl transition-all duration-200">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-4">
            <div className='flex items-center justify-center bg-gradient-to-br from-[#2a2b2e] to-[#323438] 
            h-[45px] w-[45px] rounded-full border border-[#3d3e42] shadow-inner'>
              <img alt="reward" src='/gold.svg' className='w-[20px]' />
            </div>
            
            <div>
              <h3 className="text-[15px] font-medium text-white">
                Mining Rewards
              </h3>
            </div>
          </div>

          <span className='text-[15px] font-semibold text-primary bg-primary/10 
          px-3 py-1 rounded-full border border-primary/20'>
            +{formatNumber(miningTotal)} $TFlash
          </span>
        </div>
      </div>

      {/* Premium Rewards Card - Conditionally rendered */}
      {premium && (
        <div className="w-full rounded-[16px] p-4 bg-gradient-to-br from-[#1f2023] to-[#252629] 
        border border-[#2c2d30] shadow-lg hover:shadow-xl transition-all duration-200">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-4">
              <div className='flex items-center justify-center bg-gradient-to-br from-[#2a2b2e] to-[#323438] 
              h-[45px] w-[45px] rounded-full border border-[#3d3e42] shadow-inner'>
                <img alt="reward" src='/prem.svg' className='w-[20px]' />
              </div>
              
              <div>
                <h3 className="text-[15px] font-medium text-white">
                  Telegram Premium
                </h3>
              </div>
            </div>

            <span className='text-[15px] font-semibold text-primary bg-primary/10 
            px-3 py-1 rounded-full border border-primary/20'>
              +{formatNumber(premiumReward)} $TFlash
            </span>
          </div>
        </div>
      )}
    </div>
  );
}

export default YourRewards